import { render, staticRenderFns } from "./Movimentacao.vue?vue&type=template&id=5cf4885f&scoped=true"
import script from "./Movimentacao.vue?vue&type=script&lang=js"
export * from "./Movimentacao.vue?vue&type=script&lang=js"
import style0 from "./Movimentacao.vue?vue&type=style&index=0&id=5cf4885f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf4885f",
  null
  
)

export default component.exports